<template>
  <div class="comp-toaster">
    <transition-group name="fade" mode="out-in">
      <div 
      v-for="(item, key) in toasterItems"
      v-bind:key="key"
      class="toaster-wrapper">
        <div
        v-bind:class="{
          'success': item.status === 'success',
          'info': item.status === 'info',
          'warning': item.status === 'warning',
          'error': item.status === 'error',
        }"
        v-on:click="onClickToaster(key)"
        class="toaster">
          <div class="message">{{item.message}}</div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'comp-toaster',
  data: function () {
    return {
      toasterItems: {},
      successTimeout: 1000 * 3,
      infoTimeout: 1000 * 3,
      warningTimeout: 1000 * 20,
      errorTimeout: 1000 * 60 * 5
    }
  },
  computed: {
    lastLog: function () {
      return this.$store.getters.lastLog
    }
  },
  watch: {
    lastLog: function (now, before) {
      this.onNewLogAdded()
    }
  },
  methods: {
    onNewLogAdded: function () {
      let key = this.lastLog.timestamp
      if (this.toasterItems[key] === undefined) {
        this.$set(this.toasterItems, key, {
          status: this.lastLog.status,
          message: this.lastLog.message,
          timestamp: this.lastLog.timestamp
        })
        let timeout = this.lastLog.status === 'success' ? this.successTimeout
                    : this.lastLog.status === 'info' ? this.infoTimeout
                    : this.lastLog.status === 'warning' ? this.warningTimeout
                    : this.lastLog.status === 'error' ? this.errorTimeout : null
        setTimeout(() => {
          this.hideToaster(key)
        }, timeout)
      }
    },
    onClickToaster: function (key) {
      this.hideToaster(key)
    },
    hideToaster: function (key) {
      this.$delete(this.toasterItems, key)
    }
  }
}
</script>

<style scoped>
  .comp-toaster {
    position: absolute;
    right: 6px;
    top: 6px;
    max-width: 280px;
    width: 100%;
    z-index: 1000;
  }
  .comp-toaster .toaster {
    font-size: 16px;
    box-shadow: 0 0 12px #333;
    border-radius: 3px;
    padding: 15px 15px 15px 50px;
    position: relative;
    pointer-events: auto;
    cursor: pointer;
    overflow: hidden;
    margin: 0 0 6px;
    color: #fff;
    background-position: 15px center;
    background-repeat: no-repeat;
    opacity: .8;
  }
  .comp-toaster .toaster:hover {
    opacity: 1;
  }
  .comp-toaster .toaster.success {
    background-color: rgb(81, 163, 81);
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADsSURBVEhLY2AYBfQMgf///3P8+/evAIgvA/FsIF+BavYDDWMBGroaSMMBiE8VC7AZDrIFaMFnii3AZTjUgsUUWUDA8OdAH6iQbQEhw4HyGsPEcKBXBIC4ARhex4G4BsjmweU1soIFaGg/WtoFZRIZdEvIMhxkCCjXIVsATV6gFGACs4Rsw0EGgIIH3QJYJgHSARQZDrWAB+jawzgs+Q2UO49D7jnRSRGoEFRILcdmEMWGI0cm0JJ2QpYA1RDvcmzJEWhABhD/pqrL0S0CWuABKgnRki9lLseS7g2AlqwHWQSKH4oKLrILpRGhEQCw2LiRUIa4lwAAAABJRU5ErkJggg==)!important;
  }
  .comp-toaster .toaster.info {
    background-color: rgb(47, 150, 180);
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGwSURBVEhLtZa9SgNBEMc9sUxxRcoUKSzSWIhXpFMhhYWFhaBg4yPYiWCXZxBLERsLRS3EQkEfwCKdjWJAwSKCgoKCcudv4O5YLrt7EzgXhiU3/4+b2ckmwVjJSpKkQ6wAi4gwhT+z3wRBcEz0yjSseUTrcRyfsHsXmD0AmbHOC9Ii8VImnuXBPglHpQ5wwSVM7sNnTG7Za4JwDdCjxyAiH3nyA2mtaTJufiDZ5dCaqlItILh1NHatfN5skvjx9Z38m69CgzuXmZgVrPIGE763Jx9qKsRozWYw6xOHdER+nn2KkO+Bb+UV5CBN6WC6QtBgbRVozrahAbmm6HtUsgtPC19tFdxXZYBOfkbmFJ1VaHA1VAHjd0pp70oTZzvR+EVrx2Ygfdsq6eu55BHYR8hlcki+n+kERUFG8BrA0BwjeAv2M8WLQBtcy+SD6fNsmnB3AlBLrgTtVW1c2QN4bVWLATaIS60J2Du5y1TiJgjSBvFVZgTmwCU+dAZFoPxGEEs8nyHC9Bwe2GvEJv2WXZb0vjdyFT4Cxk3e/kIqlOGoVLwwPevpYHT+00T+hWwXDf4AJAOUqWcDhbwAAAAASUVORK5CYII=)!important;
  }
  .comp-toaster .toaster.warning {
    background-color: rgb(248, 148, 6);
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGYSURBVEhL5ZSvTsNQFMbXZGICMYGYmJhAQIJAICYQPAACiSDB8AiICQQJT4CqQEwgJvYASAQCiZiYmJhAIBATCARJy+9rTsldd8sKu1M0+dLb057v6/lbq/2rK0mS/TRNj9cWNAKPYIJII7gIxCcQ51cvqID+GIEX8ASG4B1bK5gIZFeQfoJdEXOfgX4QAQg7kH2A65yQ87lyxb27sggkAzAuFhbbg1K2kgCkB1bVwyIR9m2L7PRPIhDUIXgGtyKw575yz3lTNs6X4JXnjV+LKM/m3MydnTbtOKIjtz6VhCBq4vSm3ncdrD2lk0VgUXSVKjVDJXJzijW1RQdsU7F77He8u68koNZTz8Oz5yGa6J3H3lZ0xYgXBK2QymlWWA+RWnYhskLBv2vmE+hBMCtbA7KX5drWyRT/2JsqZ2IvfB9Y4bWDNMFbJRFmC9E74SoS0CqulwjkC0+5bpcV1CZ8NMej4pjy0U+doDQsGyo1hzVJttIjhQ7GnBtRFN1UarUlH8F3xict+HY07rEzoUGPlWcjRFRr4/gChZgc3ZL2d8oAAAAASUVORK5CYII=)!important;
  }
  .comp-toaster .toaster.error {
    background-color: rgb(189, 54, 47);
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHOSURBVEhLrZa/SgNBEMZzh0WKCClSCKaIYOED+AAKeQQLG8HWztLCImBrYadgIdY+gIKNYkBFSwu7CAoqCgkkoGBI/E28PdbLZmeDLgzZzcx83/zZ2SSXC1j9fr+I1Hq93g2yxH4iwM1vkoBWAdxCmpzTxfkN2RcyZNaHFIkSo10+8kgxkXIURV5HGxTmFuc75B2RfQkpxHG8aAgaAFa0tAHqYFfQ7Iwe2yhODk8+J4C7yAoRTWI3w/4klGRgR4lO7Rpn9+gvMyWp+uxFh8+H+ARlgN1nJuJuQAYvNkEnwGFck18Er4q3egEc/oO+mhLdKgRyhdNFiacC0rlOCbhNVz4H9FnAYgDBvU3QIioZlJFLJtsoHYRDfiZoUyIxqCtRpVlANq0EU4dApjrtgezPFad5S19Wgjkc0hNVnuF4HjVA6C7QrSIbylB+oZe3aHgBsqlNqKYH48jXyJKMuAbiyVJ8KzaB3eRc0pg9VwQ4niFryI68qiOi3AbjwdsfnAtk0bCjTLJKr6mrD9g8iq/S/B81hguOMlQTnVyG40wAcjnmgsCNESDrjme7wfftP4P7SP4N3CJZdvzoNyGq2c/HWOXJGsvVg+RA/k2MC/wN6I2YA2Pt8GkAAAAASUVORK5CYII=)!important;
  }
  .comp-toaster .toaster .message {
    padding: 0;
    word-wrap: break-word;
    text-align: left;
  }

</style>



// WEBPACK FOOTER //
// CompToaster.vue?26473d65